/**
 * RESPONSIBILITY: the pastor's note.
 *
 * The letter is markdown because it is a letter: paragraphs, emphasis, a signature. It
 * is rendered on save into noteHtml, so the page ships no parser.
 *
 * No @EditableBy, so WRITE defaults to NONE — admin only.
 */
import { Section, Text, Paragraph, Img, RenderOf } from '@framework/core/decorators';
import type { ImageValue } from '@framework/core';
import { SectionName } from '../section-names';

@Section({ name: SectionName.LeadershipNote, label: "Leadership — pastor's note" })
export class LeadershipNoteSection {
  @Text({ label: 'Title', maxLength: 300, default: "Pastor's Note" })
  noteHeading!: string;

  @Paragraph({
    label: 'The letter', maxLength: 20000, rows: 12, markdown: true, allow: ['verse'],
    description: 'The note itself. Blank lines start a new paragraph.',
  })
  note!: string;

  @RenderOf('note')
  noteHtml!: string;

  @Text({
    label: 'Line shown before the letter is written', maxLength: 300,
    default: "The pastor's note has not been written yet.",
    description: 'Shown in place of the letter while there is none. Empty shows nothing.',
  })
  noteEmpty!: string;

  @Img({
    label: 'Photo', folder: 'people', maxSizeMb: 12, size: '600 × 600',
    description: 'The portrait beside the note.',
  })
  notePortrait!: ImageValue;

  @Text({
    label: 'Subtitle', maxLength: 120, default: 'From our pastor',
    description: 'The small line above the title where this note previews on the About page.',
  })
  eyebrow!: string;

  @Text({
    label: 'Leadership button', maxLength: 120, default: 'Meet our leadership',
    description: 'Closes the About page by sending the reader to the leadership page.',
  })
  moreLabel!: string;
}
